/**
 * Deli fridge items data
 * Represents refrigerated items available at the deli
 */

const deliFridgeItems = [
  {
    id: 1,
    name: "Eggs",
    category: "fridge"
  },
  {
    id: 2,
    name: "Butter",
    category: "fridge"
  },
  {
    id: 3,
    name: "Cream Cheese",
    category: "fridge"
  },
  {
    id: 4,
    name: "Yogurt",
    category: "fridge"
  },
  {
    id: 5,
    name: "Soft Drinks",
    description: "Cans & 2-liters",
    category: "fridge"
  },
  {
    id: 6,
    name: "Bottled Water",
    category: "fridge"
  },
  {
    id: 7,
    name: "Iced Teas",
    category: "fridge"
  },
  {
    id: 8,
    name: "Juices",
    category: "fridge"
  },
  {
    id: 9,
    name: "Milk",
    category: "fridge"
  },
  {
    id: 10,
    name: "Cold Beer",
    category: "fridge"
  }
];

module.exports = deliFridgeItems;